import React, { useState,useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchShops ,setSelectedShop,deleteShop, clearSelectedShop,clearAlerts} from "../store/shopSlice";
import MyDialog from "../components/MyDialog";
import AddIcon from '@mui/icons-material/Add';
import MyTable from "../components/MyTable";
import "./Shops.css";
import ShopForm from "../components/forms/ShopForm";
import MyButton from "../components/MyButton";
import MyConfirmation from "../components/MyConfirmation";
import { showSnackbar } from "../store/snackbarSlice";
import { ACTION_PERMISSIONS } from "../services/Enums";


const Shops = () => {

    // const showSnackbar = useSnackbar();
    const dispatch=useDispatch();
    const {shops,selectedShop,message,error,pagination}=useSelector((state) => state.shop)

  
  const [dialogOpen, setDialogOpen] = useState(false);
  
  useEffect(() => {
      dispatch(fetchShops({page:1,limit:5}))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);   
  
  const openDialog = () => {
    setDialogOpen(true); // Open the dialog
  };

  const closeDialog = () => {
    setDialogOpen(false); // Close the dialog
  };

  useEffect(() => {
    if (message || error) {
        const type = message ? 'success' : 'error';
        const content = message || error;
        // Show snackbar with appropriate type
        dispatch(showSnackbar({ message: content, severity: type}));
        dispatch(clearAlerts())
        // Clear the form and fetch articles if successful
        if (message) {
          dispatch(fetchShops({page:1,limit:5}));
        }
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [message, error]);

  const headers = [
    { key: 'name', label: 'Shop Name' },
    { key: 'location', label: 'Location' },
    // { key: 'users', label: 'Users' },
  ];

 const actions = [
    {
      label: 'Edit',
      type:'update',
      action: ACTION_PERMISSIONS.EDIT_SHOP,
      callback: (item) => {
        dispatch(setSelectedShop(item))
        openDialog();
      },
    },
    {
      label: 'Delete',
      type:'delete',
      action: ACTION_PERMISSIONS.DELETE_SHOP,
      callback: (item) => {
        dispatch(setSelectedShop(item))
        handleOpenConfirmDialog(item)
      },
    },
  ];


const [ConfirmDialogOpen, setConfirmDialogOpen] = React.useState(false);

const handleOpenConfirmDialog = () => {
   setConfirmDialogOpen(true)
  };

  const handleConfirm = () => {
    dispatch(deleteShop(selectedShop._id))
    dispatch(clearSelectedShop())
    setConfirmDialogOpen(false);
    
  };

  const handleCancel = (item) => {
    dispatch(clearSelectedShop())
    setConfirmDialogOpen(false);
  };
  
    const handlePageChange = (newPage, newRowsPerPage) => {
      dispatch(fetchShops({ page: newPage + 1, limit: newRowsPerPage }));
    };
  
    
  return (
    <div className="shopMainDiv">
      <div className="shopsEdit">{/* <ArticleAutocomplete /> */}</div>
    
      <div className="btnDiv">
        <MyButton
         type="create"
         action={ACTION_PERMISSIONS.ADD_SHOP}
         onClick={openDialog}
        >
          <AddIcon />
          Create Shop
        </MyButton>
      </div>
      <MyDialog
        open={dialogOpen}
        title={selectedShop?"Edit Shop":"Create Shop"}
        onDiscard={closeDialog} // Pass the discard handler
      >
        {/* Insert the children */}

        <ShopForm closeDialog={closeDialog}/>
          
      </MyDialog>
      <div style={{width:'70%'}}>
      <h2>Shop Data</h2>
          <div style={{width:'100%'}}>
          <MyTable
            headers={headers}
            totalRows={pagination?.total || 0}
            data={shops}
            actions={actions}
            defaultPageSize={5} // Initialize based on API response
            onPageChange={handlePageChange}

          />
          </div>

    </div>
     <MyConfirmation
            open={ConfirmDialogOpen}
            title="Delete Item"
            description={`Are you sure you want to delete this item ? ${selectedShop?.name || ''}`}
            onConfirm={handleConfirm}
            onCancel={handleCancel}
            confirmText="Delete"
            cancelText="Cancel"
          />
    </div>
  );
};

export default Shops;
